import connect from './connect';
import SaveAsTemplateModal from './SaveAsTemplateModal';

export default connect(SaveAsTemplateModal);
export { SaveAsTemplateModalContentsProps } from './SaveAsTemplateModalContents';
